import { useDealContext } from '../../../utils/context/DealContext.tsx';

import { DealForecastBidGuidance } from './DealForecastBidGuidance.tsx';
import { DealForecastMetrics } from './DealForecastMetrics.tsx';
import { TopMarketRequests } from './TopMarketRequests/TopMarketRequests.tsx';
import { UnforecastedTargetingVariables } from './UnforecastedTargetingVariables/UnforecastedTargetingVariables.tsx';
import { UnusedParams } from './UnusedParams/UnusedParams.tsx';

type DealForecastContentProps = {
  loading: boolean;
  job_id: string;
};

export const DealForecastContent = ({ loading, job_id }: DealForecastContentProps) => {
  const { useFetchDealForecast } = useDealContext();

  useFetchDealForecast(job_id);

  if (loading) {
    return null;
  }

  return (
    <>
      <UnusedParams />
      <DealForecastMetrics />
      <DealForecastBidGuidance />
      <TopMarketRequests />
      <UnforecastedTargetingVariables />
    </>
  );
};
